export const breakpoints = [576, 768, 992, 1200]
export const mq = breakpoints.map(
    bp => `@media (max-width: ${bp}px)`
  )

export const linkColor = "#c3c36f";